/**
 * The short note beside a money figure the API withheld because items in it
 * have no rate: "2 loads have no rate".
 *
 * The API's money sums are all-or-nothing (#815; api#851, #854): one item with
 * no rate and the figure arrives as null, with a count of the items saying
 * why. The screen shows the dash and this note. It never shows a partial sum.
 *
 * Returns null when there is nothing to say: a count of 0, or a count the API
 * did not send. A null figure with no count is still a dash, just unexplained;
 * the note is never guessed.
 */
export function missingRateNote(
  count: unknown,
  noun: { one: string; many: string },
  predicate = "no rate",
): string | null {
  const n = typeof count === "number" ? count : typeof count === "string" && count.trim() !== "" ? Number(count) : NaN;
  if (!Number.isInteger(n) || n <= 0) return null;
  return n === 1 ? `1 ${noun.one} has ${predicate}` : `${n} ${noun.many} have ${predicate}`;
}

export const LOADS = { one: "load", many: "loads" };
